import * as api from '../api'
import * as url from '../../api_urls'

export const fetchClinicTreatmentList = clinicID => {
  return new Promise((resolve, reject) => {
    return api
      .get(url.clinics + clinicID + '/treatments/')
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const fetchTreatmentTypeList = clinicId => {
  return new Promise((resolve, reject) => {
    return api
      .get(`/consultations/${clinicId}/calendar/treatment-types/`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getFilteredPatientsList = data => {
  return new Promise((resolve, reject) => {
    return api
      .get(url.clinics + data.id + '/patients/?find=' + data.patient)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
